import { Component, Input, NgZone, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import {
    Customer
} from '../../models/models';

@Component({
    selector: 'customer-child-grid',
    templateUrl: './customer-child-grid.component.html',
    standalone: false
})
export class CustomerChildGrid implements OnChanges {
    @Input() parentCustomerID: number = 0;

    @ViewChild(GridComponent, { static: false }) public childCustomerGrid!: GridComponent;

    public isAdd: boolean = false;

    public childCustomerList: Customer[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'eventDate' }] };

    constructor(private crmService: CRMService, private utilService: UtilService, public dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getChildCustomers();
    }

    private getChildCustomers() {
        this.utilService.isLoading = true;
        this.crmService.getChildCustomersByCustomerId(this.parentCustomerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.childCustomerList = result;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.childCustomerList = orderBy(this.childCustomerList, this.gridState.sort);

        this.gridData = process(this.childCustomerList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.childCustomerGrid == null) return;
            this.childCustomerGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public delete(customerID: number) {
        var idx = this.childCustomerList.findIndex(c => c.customerID == customerID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Remove Child?',
            message: 'Would you like to remove this child?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            var cust: Customer = this.childCustomerList[idx];
            cust.parentCustomerId = 0;
            this.crmService.saveCustomer(cust).subscribe(result => {
                this.getChildCustomers();
            });
        });
    }

    public addNew() {
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isAdd = false;
        this.getChildCustomers();
    }
}
